/**
 * @file wq-antispam.js
 * @description Email obfuscation decoder + form honeypot/timestamp bot detection.
 *   - Finds all .wq-email elements and assembles mailto links from data-u + data-d
 *   - Finds all forms with [data-wq-honeypot] and intercepts bot submissions
 *   - Namespaced under window.WQ.AntiSpam (RULE-06)
 * @sprint Anti-Spam | 2026-03-05
 */
window.WQ = window.WQ || {};

window.WQ.AntiSpam = (() => {
  'use strict';

  /* ── Guard: run once even if loaded multiple times ── */
  if (window.WQ.AntiSpam && window.WQ.AntiSpam._initialized) {
    return window.WQ.AntiSpam;
  }

  const PAGE_LOAD_TIME = Date.now();
  const MIN_SUBMIT_MS = 3000;

  /* ──────────────────────────────────────────────
     1. Email Obfuscation Decoder
     ────────────────────────────────────────────── */

  function decodeEmails() {
    document.querySelectorAll('.wq-email[data-u][data-d]').forEach(function (el) {
      var user = el.getAttribute('data-u');
      var domain = el.getAttribute('data-d');
      if (!user || !domain) return;

      var email = user + '@' + domain;
      var link = document.createElement('a');
      link.href = 'mailto:' + email;
      link.textContent = email;

      /* Preserve classes from the original span (minus wq-email itself) */
      var classes = el.className.replace('wq-email', '').trim();
      if (classes) link.className = classes;

      el.parentNode.replaceChild(link, el);
    });
  }

  /* ──────────────────────────────────────────────
     2. Form Honeypot + Timestamp Detection
     ────────────────────────────────────────────── */

  function protectForms() {
    document.querySelectorAll('[data-wq-honeypot]').forEach(function (marker) {
      var form = marker.closest('form') || (marker.tagName === 'FORM' ? marker : null);
      if (!form) return;

      form.addEventListener('submit', function (e) {
        /* Check honeypot field */
        var honeypot = form.querySelector('input[name="company_url"]');
        if (honeypot && honeypot.value !== '') {
          e.preventDefault();
          e.stopImmediatePropagation();
          showFakeSuccess(form);
          return;
        }

        /* Check timestamp — too fast = bot */
        if (Date.now() - PAGE_LOAD_TIME < MIN_SUBMIT_MS) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showFakeSuccess(form);
          return;
        }

        /* Legitimate submission — allow normal flow */
      }, true); /* capture phase: runs before other handlers */
    });
  }

  function showFakeSuccess(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Message Sent!';
      btn.style.background = '#16a34a';
      btn.style.cursor = 'default';
    }
  }

  /* ──────────────────────────────────────────────
     3. Init
     ────────────────────────────────────────────── */

  function init() {
    decodeEmails();
    protectForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var api = { decodeEmails: decodeEmails, protectForms: protectForms, _initialized: true };
  return api;
})();
